import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from 'components/InfoPage';

export const path = '/cookies';
export const link = path;

const Cookies = props => {
    const [t] = useTranslation("cookies");
    return <InfoPage t={t} />
}

Cookies.path = path;

export default Cookies;